<template>
  <div class="container booking-container">
    <div class="booking-row">
      <div class="copy">
        <p>Progress starts NOW - Book today!</p>
      </div>
      <div class="booking-form">
        <button @click="openCalendly" class="booking-button">BOOK NOW</button>
      </div>
    </div>
  </div>
</template>


<script>

  // import '../calendly';
  export default {
    mounted() {
      let calendlyScript = document.createElement('script')
      calendlyScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
      document.head.appendChild(calendlyScript)
    },
    methods: {
      openCalendly() {
        
        Calendly.showPopupWidget('https://calendly.com/jackieserviss');
        return false;

        $('.calendly-overlay').style.zIndex="10000";

      }
    }
  }
  
</script>

<style scoped>
  @import "https://assets.calendly.com/assets/external/widget.css";
  .booking-container {
    background-color: #ebebeb;
    /*padding: 0 60px;*/
    height: 100px;
    display: flex;
    justify-content: center;
  }
  .booking-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 70%;
    text-align: center;
  }

  .booking-row p {
    color: #333333;
    padding: 10px 0px;
    font-size: 24px;
    margin: 0;
    font-family: brandon-grotesque, sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .copy, 
  .booking-form { width: 50%; }

  .booking-input {
    border: none;
    border-radius: 5px 0 0 5px;
    padding: 17px 20px;
    font-size: 20px;
    width: 50%;
  }

  .booking-button {
    border: none;
    background-color: #2e3192;
    color: #fff;
    font-size: 20px;
    padding: 17px 30px 17px 30px;
    border-radius: 5px;
    left: -4px;
    position: relative;
    transition: all 0.15s linear;
  }
  .booking-button:hover {
    background-color: #5c5eb4;
  }

  .booking-button:focus {
    outline: none;
  }

  .calendly-overlay { z-index: 1000000 !important; }

  @media ( max-width: 775px ) {
    .booking-container {
      height: auto;
      padding: 20px 0;
    }
    .booking-container .booking-row { flex-direction: column; }
    .copy, .booking-form { width: 100%; }
    .booking-container p { padding-top: 0; }
  }


</style>a


// WEBPACK FOOTER //
// src/components/BookingSignup.vue